import DefaultLayout from "@/layouts/default";
import Carousel from "@/components/Carousel";

function index() {
  return (
    <>
      <DefaultLayout>
        <Carousel />
      </DefaultLayout>
    </>
  );
}

export default index;
